import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const IconTestGroup = ({ className }) => {
  return (
    <svg
      width='85'
      height='85'
      viewBox='0 0 85 85'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M42.5 85C65.9721 85 85 65.9721 85 42.5C85 19.0279 65.9721 0 42.5 0C19.0279 0 0 19.0279 0 42.5C0 65.9721 19.0279 85 42.5 85Z'
        fill='white'
      />
      <path
        d='M57.8001 52.2C51.0001 49.6 43.5001 46.4 42.8001 44.3V42.2C44.3016 40.5791 45.3982 38.6259 46.0001 36.5C46.7207 35.9788 47.2152 35.2021 47.3825 34.3285C47.5497 33.455 47.3772 32.5506 46.9001 31.8C46.8001 31.7 46.8001 31.6 46.7001 31.5V26.7C46.7001 21.8 43.9001 18.5 37.7001 18.5C31.5001 18.5 28.7001 21.9 28.7001 26.7V31.5C28.1276 32.1942 27.8491 33.0847 27.9238 33.9814C27.9985 34.8781 28.4206 35.7101 29.1001 36.3C29.2001 36.4 29.3001 36.4 29.4001 36.5C30.0015 38.6557 31.0972 40.6416 32.6001 42.3V44.4C32.0001 46.4 24.4001 49.6 17.6001 52.3C17.3099 52.4026 17.0583 52.5919 16.8794 52.8424C16.7005 53.0928 16.603 53.3922 16.6001 53.7V58.9C16.6102 59.2946 16.7715 59.6703 17.0506 59.9495C17.3298 60.2286 17.7055 60.3899 18.1001 60.4H57.3001C57.6947 60.3899 58.0704 60.2286 58.3495 59.9495C58.6287 59.6703 58.79 59.2946 58.8001 58.9V53.6C58.7972 53.2922 58.6997 52.9928 58.5208 52.7424C58.3419 52.4919 58.0903 52.3026 57.8001 52.2Z'
        fill='#D8D8D8'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M48.3002 43.3C46.2426 45.357 44.8412 47.9781 44.2732 50.8317C43.7053 53.6853 43.9963 56.6432 45.1096 59.3313C46.2228 62.0195 48.1082 64.3171 50.5273 65.9337C52.9465 67.5502 55.7907 68.4131 58.7002 68.4131C61.6098 68.4131 64.454 67.5502 66.8731 65.9337C69.2923 64.3171 71.1777 62.0195 72.2909 59.3313C73.4042 56.6432 73.6952 53.6853 73.1273 50.8317C72.5593 47.9781 71.1579 45.357 69.1002 43.3C67.7364 41.9309 66.1156 40.8446 64.3309 40.1034C62.5462 39.3621 60.6327 38.9806 58.7002 38.9806C56.7677 38.9806 54.8543 39.3621 53.0696 40.1034C51.2849 40.8446 49.6641 41.9309 48.3002 43.3Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M62.5998 43.6C61.3811 43.0294 60.0447 42.7553 58.6998 42.8C55.8114 42.8079 53.0435 43.9588 51.0011 46.0013C48.9587 48.0437 47.8077 50.8116 47.7998 53.7C47.7998 56.5909 48.9482 59.3633 50.9923 61.4075C53.0365 63.4516 55.8089 64.6 58.6998 64.6C61.5907 64.6 64.3631 63.4516 66.4073 61.4075C68.4514 59.3633 69.5998 56.5909 69.5998 53.7C69.6038 52.6374 69.4 51.5843 68.9998 50.6'
        fill='#FFD356'
      />
      <path
        d='M62.5998 43.6C61.3811 43.0294 60.0447 42.7553 58.6998 42.8C55.8114 42.8079 53.0435 43.9588 51.0011 46.0013C48.9587 48.0437 47.8077 50.8116 47.7998 53.7V53.7C47.7998 56.5909 48.9482 59.3633 50.9923 61.4075C53.0365 63.4516 55.8089 64.6 58.6998 64.6C61.5907 64.6 64.3631 63.4516 66.4073 61.4075C68.4514 59.3633 69.5998 56.5909 69.5998 53.7C69.6038 52.6374 69.4 51.5843 68.9998 50.6'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M71.2002 41.2L58.7002 56L53.2002 51.3'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

IconTestGroup.propTypes = {
  className: PropTypes.string
}

const StyledIconTestGroup = styled(IconTestGroup)`
  height: 150px;
`

export default StyledIconTestGroup
